import React from 'react';
import { Pagination, Row, Col } from 'react-bootstrap';

const PaginationComponent = ({ totalPages, currentPage, onPageChange, totalElements, size, pageNumber, numberOfElements }) => {
  const handleClick = (page) => {
    onPageChange(page);
  };

  const generatePaginationItems = () => {
    const items = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handleClick(i)}>
            {i}
          </Pagination.Item>
        );
      }
    } else {
      items.push(
        <Pagination.Item key={1} active={1 === currentPage} onClick={() => handleClick(1)}>
          1
        </Pagination.Item>
      );

      if (currentPage > 3) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }

      for (let i = Math.max(2, currentPage - 1); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
        items.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handleClick(i)}>
            {i}
          </Pagination.Item>
        );
      }

      if (currentPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }

      items.push(
        <Pagination.Item key={totalPages} active={totalPages === currentPage} onClick={() => handleClick(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  const start = totalElements > 0 ? pageNumber * size + 1 : 0;
  const end = totalElements > 0 ? start + numberOfElements - 1 : 0;

  return (
    <Row className="align-items-center mt-3">
      <Col xs={12} md={6} className="d-flex justify-content-md-start justify-content-center mb-2 mb-md-0">
        <div className="text-md-start text-center">
          {totalElements > 0 ? (
            <span>
              Exibindo {start} - {end} de {totalElements}
            </span>
          ) : (
            <span>Nenhum resultado encontrado</span>
          )}
        </div>
      </Col>
      <Col xs={12} md={6} className="d-flex justify-content-md-end justify-content-center">
        <Pagination className="m-0">
          <Pagination.Prev
            onClick={() => handleClick(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {generatePaginationItems()}
          <Pagination.Next
            onClick={() => handleClick(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </Col>
    </Row>
  );
};

export default PaginationComponent;